import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Text } from 'office-ui-fabric-react/lib/Text';
import styles from './DataItem.style';

const DataItem = ({ label, children, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp);

  return (
    children && (
      <Text as="p" variant="small" block className={className} {...other}>
        {label && `${label}: `}
        <strong>{children}</strong>
      </Text>
    )
  );
};

DataItem.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

DataItem.defaultProps = {
  label: '',
  children: null,
  className: '',
};

export default DataItem;
